module.exports = __webpack_public_path__ + "media/asset/images/TokyoGAS/ITRI_company_resource_TokyoGAS-cfe24b9bf9ce48124630a666b16d9ac7.png";